import { Root as CheckboxRoot, Indicator as CheckboxIndicator } from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { cn } from '@/lib/utils';
import { Label } from '@/components/ui/FormFields/Label';

type CheckboxProps = {
  label?: string | React.ReactNode;
  id?: string;
  labelClassName?: string;
  required?: boolean;
  wrapperClassName?: string;
} & ComponentPropsWithoutRef<typeof CheckboxRoot>;

export const Checkbox = forwardRef<React.ElementRef<typeof CheckboxRoot>, CheckboxProps>(
  ({ className, label, id, labelClassName, required, wrapperClassName, ...props }, ref) => {
    return (
      <div className={cn('flex flex-col items-start gap-2', wrapperClassName)}>
        {label && (
          <Label htmlFor={id} required={required} className={cn('text-primary text-xs font-semibold', labelClassName)}>
            {label}
          </Label>
        )}
        <CheckboxRoot
          ref={ref}
          id={id}
          className={cn(
            'border-input ring-offset-background focus-visible:ring-ring data-[state=checked]:border-primary peer size-4 shrink-0 rounded-sm border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
            className
          )}
          required={required}
          {...props}
        >
          <CheckboxIndicator className="text-primary flex items-center justify-center">
            <Check className="size-4" />
          </CheckboxIndicator>
        </CheckboxRoot>
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';
